module.exports = __webpack_public_path__ + "cd82ee1a4e2f568b2ac4eb61d818bee9.pdf";